import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@beecore/auth';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/home-page/home-page.module').then(x => x.HomePageModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'acompprocessamento',
    loadChildren: () => import('./pages/acomp-processamento-pages/acomp-processamento-pages.module').then(x => x.AcompProcessamentoPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'exportvisaogerencial',
    loadChildren: () => import('./pages/export-visao-gerencial-pages/export-visao-gerencial-pages.module').then(x => x.ExportVisaoGerencialPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'tsfecontrolerelatorio',
    loadChildren: () => import('./pages/controle-relatorio-pages/controle-relatorio-pages.module').then(x => x.ControleRelatorioPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'cadastrodashboard',
    loadChildren: () => import('./pages/cadastro-dashboard-pages/cadastro-dashboard-pages.module').then(x => x.CadastroDashboardPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'auditorias',
    loadChildren: () => import('./pages/auditoria-pages/auditoria-pages.module').then(x => x.AuditoriaPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'documentofiscal',
    loadChildren: () => import('./pages/documento-fiscal-pages/documento-fiscal-pages.module').then(x => x.DocumentoFiscalPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'consultasefaz',
    loadChildren: () => import('./pages/consulta-sefaz-pages/consulta-sefaz-pages.module').then(x => x.ConsultaSefazPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'filaprocessamentodocto',
    loadChildren: () => import('./pages/fila-processamento-docto-pages/fila-processamento-docto-pages.module').then(x => x.FilaProcessamentoDoctoPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'filaprocessamentodetalhe',
    loadChildren: () => import('./pages/fila-processamento-detalhe-pages/fila-processamento-detalhe-pages.module').then(x => x.FilaProcessamentoDetalhePagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'centralnotificacoes',
    loadChildren: () => import('./pages/central-notificacoes-pages/central-notificacoes-pages.module').then(x => x.CentralNotificacoesPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'consultansufaltante',
    loadChildren: () => import('./pages/consulta-nsu-faltante-pages/consulta-nsu-faltante-pages.module').then(x => x.ConsultaNsuFaltantePagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'docscanceladoscominconsistencia',
    loadChildren: () => import('./pages/docs-cancelados-com-inconsistencia-pages/docs-cancelados-com-inconsistencia-pages.module').then(x => x.DocsCanceladosComInconsistenciaPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'docscorrigidosporcartacorrecao',
    loadChildren: () => import('./pages/docs-corrigidos-por-carta-correcao-pages/docs-corrigidos-por-carta-correcao-pages.module').then(x => x.DocsCorrigidosPorCartaCorrecaoPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'controleprocessamentosfe',
    loadChildren: () => import('./pages/controle-processamento-sfe-pages/controle-processamento-sfe-pages.module').then(x => x.ControleProcessamentoSfePagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/auth-page/auth-page.module').then(x => x.AuthPageModule)
  },
  {
    path: 'comunicacaocpd',
    loadChildren: () => import('./pages/comunicacao-cpd-pages/comunicacao-cpd-pages.module').then(x => x.ComunicacaoCpdPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'comunicacaocpddetalhe',
    loadChildren: () => import('./pages/comunicacao-cpd-detalhe-pages/comunicacao-cpd-detalhe-pages.module').then(x => x.ComunicacaoCpdDetalhePagesModule),
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'comunicacaowsauditor',
    loadChildren: () => import('./pages/comunicacao-ws-auditor-pages/comunicacao-ws-auditor-pages.module').then(x => x.ComunicacaoWsAuditorPagesModule),
    canActivate: [
      AuthGuard
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
